export class CacheService {
    constructor() {
      this.cache = new Map();
      this.maxSize = 100;
    }
  
    /**
     * Get cached value or execute function
     * @param {string} key - Cache key
     * @param {Function} fn - Function to execute if not cached
     * @returns {any} Cached or computed value
     */
    get(key, fn) {
      if (this.cache.has(key)) {
        return this.cache.get(key);
      }
  
      const value = fn();
      this.set(key, value);
      return value;
    }
  
    /**
     * Set cache value
     * @param {string} key - Cache key
     * @param {any} value - Value to cache
     */
    set(key, value) {
      // Prevent memory leaks by limiting cache size
      if (this.cache.size >= this.maxSize) {
        const firstKey = this.cache.keys().next().value;
        this.cache.delete(firstKey);
      }
  
      this.cache.set(key, value);
    }
  
    /**
     * Clear specific cache entry
     * @param {string} key - Cache key to clear
     */
    delete(key) {
      this.cache.delete(key);
    }
  
    /**
     * Clear all cache
     */
    clear() {
      this.cache.clear();
    }
  
    /**
     * Get cache size
     * @returns {number} Number of cached items
     */
    size() {
      return this.cache.size;
    }
  }
  
  /**
   * Singleton instance for global use
   */
  export const cacheService = new CacheService();